<template>
  <div class="flex flex-col w-full text-main-text">
    <h2 class="md:-mt-13  w-1/2">Все команды({{storeTeamsCount}})</h2>
    <confirm-delete key="delete_modal" v-if="delete_modal" @close="delete_modal = false"
                          :ids="ids" :fetch_func="fetch_func"
                          @white_button="delete_modal = false" @yellow_button="remove();"
                          :text="'Вы уверены, что хотите удалить команду?'"
                          :button_text_firs="'Отменить'" :button_text_second="'Удалить'"
                          class="z-100 flex absolute pin"></confirm-delete>
    <team-filter :main-url="`${base}/teams?sort=name,-id&city_id=${this.formCity}&limit=${currentPageSize}&`" :route="$route">
      <div
        class="w-full h-full flex justify-start py-2 items-start flex-col relative"
        slot-scope="{linked, values}"
      >

        <pagination :client="client" :base-url="linked" @data ="setTeamsCount">
          <div class="w-full" slot-scope="{data: teams, processing, switchPage, fetchData}">
            <spinner v-if="!isHaveData" class="mt-32"></spinner>
            <div v-else class="py-3 px-8 my-6 border border-grey-dark rounded-lg bg-white overflow-auto">
              <div class="flex justify-between w-full">
                <div class="flex text-sm ml-6">
                  <span class="text-additional-text font-semibold  mr-4">Показывать по:</span>
                  <div  v-for="size in pageSizes"
                        :key="size"
                        v-text="size"
                        class="mr-4"
                        :class="[size!==currentPageSize ? 'underline cursor-pointer hover:no-underline':'cursor-default']"
                        @click.prevent.stop="currentPageSize = size"></div>
                </div>

                <div class="whitespace-no-wrap flex items-center text-sm">
                  <div class="rounded-full h-2 w-2 mx-auto bg-brand-yellow mr-2"></div>
                  Команда удалена
                </div>

                <div class="flex flex-row justify-center items-center whitespace-no-wrap text-sm">
                  <p class="text-additional-text font-bold">Сортировка:</p>
                  <filter-teams></filter-teams>
                  <!--<img class="ml-12 cursor-pointer" src="@/assets/SVG/download-data-base.svg" @click="downloadExcel" alt />-->
                </div>

              </div>
              <div class="w-full flex justify-end h-16 mt-2">

                <button
                  v-if="selectedTeams.length"
                  v-text="selectedTeams.length > 1 ? 'Удалить все' : 'Удалить'"
                  @click.prevent="remove_items(selectedTeams, fetchData)"
                  class="rounded-full border-brand-light bg-brand-light outline-none text-white ml-4 h-10 text-base font-semibold px-8 mt-6 -mb-4"
                >Удалить все</button>
              </div>
              <table v-if="teams.length >0" class="w-full h-full relative mt-6 text-sm">
                <thead class>
                  <tr>
                    <th><!--
                      <div
                        class="mr-auto my-auto w-6 h-6 relative"
                        :class="{'selectedClass': delete_all, 'unSelectedClass': !delete_all}"
                        title="Выбрать всё на этой странице"
                        @click.prevent="selectAll(teams)"
                      ></div> -->
                      <div class="rounded-full bg-white h-2 w-2 mx-auto">
                      </div>
                    </th>
                    <th>№</th>
                    <th class="pl-2 w-64">Название команды</th>
                    <th class="min-w-40">Имя капитана</th>
                    <th>№ телефона</th>
                    <th class="min-w-40">E-mail</th>
                    <th>Кол-во участий</th>
                  </tr>
                </thead>
                <tbody>
                  <data-base-line
                    v-for="(team, key) in teams"
                    :team="team"
                    @selectTeam="selectTeam(team.id)"
                    :checked="selectedTeams.indexOf(team.id) !== -1"
                    :key="team.id"
                    :teamCount="(currentPage-1)*currentPageSize+key+1"
                    ref="table"
                  ></data-base-line>
                </tbody>
              </table>
              <p v-else class="text-4xl text-center mt-12 font-semibold text-additional-text h-30vh flex flex-col justify-start">
                  Поиск не дал результатов
                </p>
            </div>
            <pagination-links v-if="isHaveData" @page="switchPage"></pagination-links>
          </div>
        </pagination>
      </div>
    </team-filter>
  </div>
</template>

<script>
import FileDownload from 'js-file-download';
import FilterTeams from './filter-teams';
import DataBaseLine from './data-base-line';
import client from '@/clients/partners';
import { mapActions, mapState } from 'vuex';
import map from 'lodash/map';
import swal from 'sweetalert2';
import teamFilter from '@/helpers/pagination/filter.vue';
import pagination from '@/helpers/pagination/pagination.vue';
import paginationLinks from '@/helpers/pagination/pagination-links.vue';
import ConfirmDelete from '@/views/partners/events/order/delete-modal.vue';

export default {
  name: 'data-base-page',
  components: {
    DataBaseLine,
    FilterTeams,
    teamFilter,
    pagination,
    paginationLinks,
    ConfirmDelete,
  },
  data() {
    return {
      teams: [],
      delete_list: [],
      selectedTeams: [],
      delete_all: false,
      delete_modal: false,
      base: process.env.VUE_APP_MP_PARTNERS_BACKEND,
      delete_conformition: false,
      ids: '',
      fetch_func: '',
      client,
      pageSizes: [10, 20, 50],
      currentPageSize: '',
      teamsCount: '',
      currentPage: '',
      isHaveData: false,

    };
  },
  updated() {

  },
  created() {
    if (this.storePageSize) { this.currentPageSize = this.storePageSize; } else this.currentPageSize = 10;
  },
  computed: {
    ...mapState({
      formCity: state => state.auth.user.city_id,
      storePageSize: state => state.partnersDbParams.dbPageSize,
      storeTeamsCount: state => state.partnersDbParams.dbTeamsCount,
    }),
  },

  watch: {
    currentPageSize(val) {
      console.log(val);
      this.selectdbPageSize(val);
    },
  },
  methods: {
    ...mapActions(['selectShowModal', 'selectdbPageSize', 'selectModalText', 'selectdbTeamsCount']),
    selectAll(teams) {
      const teamIds = map(teams, 'id');
      if (this.selectedTeams.length === teamIds.length) {
        this.clearSelected();
      } else {
        this.selectedTeams = teamIds;
        this.delete_all = true;
      }
    },
    selectTeam(id) {
      if (this.selectedTeams.indexOf(id) !== -1) {
        this.dropSelected(this.selectedTeams, id);
      } else {
        this.selectedTeams.push(id);
      }
    },
    clearSelected() {
      this.selectedTeams = [];
      this.delete_all = false;
    },
    dropSelected(array, id) {
      const index = array.indexOf(id);
      if (index !== -1) array.splice(index, 1);
    },
    remove_items(ids, fetchData) {
      this.ids = ids; this.fetch_func = fetchData;

      this.delete_modal = true;
    },
    remove() {
      if (this.ids.length === 0) {
        swal(
          'Выберите данные!',
          'Необходимо выбрать элементы для удаления',
          'error',
        );
        return;
      }
      let message;
      let link;
      this.ids = this.ids.join('&ids[]=');
      link = `/teams?ids[]=${this.ids}`;
      message = 'Выбраные элементы будут удалены!';
      client.delete(link).then(() => {
        this.fetch_func();
        this.clearSelected();
        this.selectModalText('Удаление завершено'); this.selectShowModal(true);
        this.delete_modal = false;
      });
    },
    downloadExcel() {
      client.get('teams/excels', { responseType: 'blob' })
        .then((response) => {
          FileDownload(response.data, 'Выгрузка.xlsx');
        });
    },
    ...mapActions({
      selectCity: 'selectCity',
    }),
    setTeamsCount(data) {
      this.teamsCount = data.meta.total;
      this.currentPage = data.meta.current_page;
      this.isHaveData = true;
      this.selectdbTeamsCount(data.meta.total);
    },

  },
};
</script>

<style scoped>
.selectedClass {
  border-radius: 2px;
  border: 2px solid #979797;
  outline: 2px solid white;
  outline-offset: -4px;
  padding: 3px;
  background-color: #bd006c;


}


.unSelectedClass {
  background-color: #fff;
  border-radius: 2px;
  border: 2px solid #ccc;
}
th{
  @apply text-left;
}
td {
  @apply text-left
        p-2 font-sans text-sm;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
}
.pagination >>> a {
  display: inline-block;
  position: relative;
  @apply font-bold text-main-text no-underline;
}
.pagination >>> a.prev {
  margin-right: 30px;
}
.pagination >>> a.next {
  margin-left: 30px;
}
.pagination >>> a.prev::before {
  position: absolute;
  display: inline-block;
  top: 2px;
  right: 100%;
  margin-right: 20px;
  content: url('../../../assets/SVG/next.svg');
  transform: scale(-1, 1)
}
.pagination >>> a.next::after {
  position: absolute;
  display: inline-block;
  top: 2px;
  left: 100%;
  margin-left: 20px;
  content: url('../../../assets/SVG/next.svg');
}
.pagination >>> a.next.disabled, .pagination >>> a.prev.disabled {
  opacity: 0.5
}
.pagination >>> .circle {
  margin: 0 10px;
  width: 35px;
  height: 35px;
  @apply rounded-full border border-main-text p-3 flex justify-center items-center;
}
.pagination >>> .circle.active {
  @apply bg-brand-yellow border-brand-yellow;
}
>>> .swal2-popup .swal2-styled.swal2-confirm {
  background-color: red !important;
}
</style>
